import {
  ROLE_TYPE_CAREGIVER,
  ROLE_TYPE_MHP,
  ROLE_TYPE_NURSE,
  ROLE_TYPE_PROVIDER,
} from "./RegisterConstants";

// Keep these names aligned with DEMO_SLOT_FEATURE_OPTIONS in the auth Lambda.
const INVITE_FEATURES_BY_ROLE: Record<string, string[]> = {
  [ROLE_TYPE_PROVIDER]: [
    "Care Plans",
    "eMAR",
    "Daily Notes",
    "Incident Reports",
    "Behavior Tracker",
    "Staff Management",
    "Document Management",
    "AI / Automation Tools",
  ],
  [ROLE_TYPE_NURSE]: [
    "Care Plans",
    "eMAR",
    "Daily Notes",
    "Incident Reports",
    "Behavior Tracker",
    "Provider-Nurse Workspace",
    "Document Management",
    "AI / Automation Tools",
  ],
  [ROLE_TYPE_CAREGIVER]: [
    "eMAR",
    "Daily Notes",
    "Behavior Tracker",
    "Shared Calendar",
    "Document Management",
  ],
  [ROLE_TYPE_MHP]: [
    "Care Plans",
    "Daily Notes",
    "Incident Reports",
    "Behavior Tracker",
    "Document Management",
    "AI / Automation Tools",
  ],
};

const INVITE_ROLE_LABELS: Record<string, string> = {
  [ROLE_TYPE_PROVIDER]: "provider",
  [ROLE_TYPE_NURSE]: "nurse",
  [ROLE_TYPE_CAREGIVER]: "caregiver",
  [ROLE_TYPE_MHP]: "mental health professional",
};

export const getInviteFeatureNames = (roleType: string) => (
  INVITE_FEATURES_BY_ROLE[String(roleType || "").trim().toLowerCase()]
  || INVITE_FEATURES_BY_ROLE[ROLE_TYPE_PROVIDER]
);

export const buildInviteMessage = (brandName: string, roleType: string) => {
  const roleFeatures = getInviteFeatureNames(roleType);
  const featureLines = roleFeatures.slice(0, 5).map((feature) => `• ${feature}`).join("\n");
  const roleLabel = INVITE_ROLE_LABELS[String(roleType || "").trim().toLowerCase()] || "care team";
  return `Hey! Check out ${brandName} — a simple hub for ${roleLabel} work and care planning.\n\nIt includes helpful features like:\n${featureLines}\n\nTake a look and see how ${brandName} can make day-to-day work easier.`;
};
